import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Input, Button, Icon } from "antd";

import './style.css';
const InputProps = {...Input.defaultProps,...Input.propTypes,onChange:()=>{}}

/**
 * Input输入框
 */
class RmtPhoneInput extends PureComponent {
    constructor(props) {
        super(props);
        
        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            isVisible: true,
            plaintext: "",
            encrypt: "",
            value:""
        };
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        let stateTemp = {...state} 
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtPhoneInput.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(InputProps[fieldKey]){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }
            stateTemp = {...state,fieldProps:{...newProps}}
        }
        return stateTemp
    }

    renderSuffixButton() {
        const { buttonProps={} } = this.props.fieldProps;
        return (
            <>
                <Button {...buttonProps}>{buttonProps?.name}</Button>
            </>
        )
    }

    render() {
        const { prefixLayout, suffixLayout, style={}, suffixButton } = this.props.fieldProps;
        const { fieldProps, suffixWidth, isVisible, plaintext, encrypt } =this.state;
        const { name } = this.props;
        
        return (
            <>
                <div className="rmt-input">
                    {
                        !!prefixLayout&&<div className="rmt-input-prefix-layout">{prefixLayout}</div>
                    }
                    <div className="rmt-input-content-layout" style={style}>
                        {/* <Input  {...fieldProps} hidden  /> */}
                        <Input
                            {...fieldProps}
                            value={isVisible?plaintext : encrypt}
                            suffix={isVisible?<Icon className="suffix-icon"  type="eye" onClick={()=>this.visibleChange(!isVisible)} />: <Icon className="suffix-icon"  type="eye-invisible" onClick={()=>this.visibleChange(!isVisible)} />}
                            readOnly={!isVisible}
                            onChange={(e)=>{
                                this.setState({value:e.target.value})
                                fieldProps.onChange(e.target.value);
                            }}
                        />
                    </div>
                    {
                        (!!suffixLayout&&!suffixButton)&&<div className="rmt-input-suffix-layout">{suffixLayout}</div>
                    }
                    {
                        (!!suffixButton&&!suffixLayout)&&<div className="rmt-input-suffix-layout">{this.renderSuffixButton()}</div>
                    }
                </div>
                <style>
                    {
                        `div[name = '${this.props.name}'] .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                    }
                </style>
            </>
        )
    }

    visibleChange(value) {
        this.setState({
            isVisible: value
        })
    }

    phoneChange(e) {
        
    }
}
export default RmtPhoneInput;

RmtPhoneInput.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtPhoneInput.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
}